import React, { useContext, useState, useEffect } from 'react';
import { Card, Container, Row } from 'react-bootstrap';
import PortfolioContext from '../../context/context';

import Timeline from '@material-ui/lab/Timeline';
import TimelineItem from '@material-ui/lab/TimelineItem';
import TimelineSeparator from '@material-ui/lab/TimelineSeparator';
import TimelineConnector from '@material-ui/lab/TimelineConnector';
import TimelineContent from '@material-ui/lab/TimelineContent';
import TimelineDot from '@material-ui/lab/TimelineDot';
import TimelineOppositeContent from '@material-ui/lab/TimelineOppositeContent';
import Typography from '@material-ui/core/Typography';
import Icon from '@material-ui/core/Icon';
import Fade from 'react-reveal/Fade';

import { makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import WorkAccordion from './WorkAccordion';
import { Paper, Link } from '@material-ui/core';


const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    heading: {
        textAlign: 'left',
        fontSize: theme.typography.pxToRem(26),
        fontWeight: theme.typography.fontWeightBold,
    },
    details: {
        textAlign: 'left',
        fontSize: theme.typography.pxToRem(20),
    }
}));

const WorkTimeline = () => {
    const { workExperience } = useContext(PortfolioContext);
    const [isDesktop, setIsDesktop] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const classes = useStyles();

    useEffect(() => {
        if (window.innerWidth > 769) {
            setIsDesktop(true);
            setIsMobile(false);
        } else {
            setIsMobile(true);
            setIsDesktop(false);
        }
    }, []);


    return (
        <section id="work-experience">
            <Container>
                {
                    isDesktop ?
                        <Timeline align="right">
                            {workExperience.map(e => {
                                return (
                                    <Fade
                                        key={e.id}
                                        left={isDesktop}
                                        bottom={isMobile}
                                        duration={1000}
                                        delay={500}
                                        distance="30px"
                                    >
                                        <TimelineItem >
                                            <TimelineOppositeContent>
                                                <Typography color="textSecondary" variant='h6'>{e.date}</Typography>
                                            </TimelineOppositeContent>
                                            <TimelineSeparator>
                                                <TimelineDot>
                                                    <Icon className={`fa fa-${e.icon}`} fontSize="small" />
                                                </TimelineDot>
                                                <TimelineConnector />
                                            </TimelineSeparator>
                                            <TimelineContent>
                                                {
                                                    <Paper elevation={1} className="p-3 work-card">
                                                        <Typography className={classes.heading}>{e.workTitle}</Typography>
                                                        <Typography variant="h5" align='left'>
                                                            {e.link ?
                                                                <a href={e.link} target='_blank'>{e.companyName} </a>
                                                                :
                                                                e.companyName
                                                            }
                                                        </Typography>
                                                        <hr />
                                                        <Typography className={classes.details}>{e.details}</Typography>
                                                    </Paper>
                                                    // e.details ?
                                                    //     <WorkAccordion details={e.details} head={e.data} />
                                                    //     :
                                                    //     <Typography variant="h5">{e.data}</Typography>
                                                }
                                            </TimelineContent>
                                        </TimelineItem>
                                    </Fade>
                                )
                            })}

                        </Timeline>
                        :
                        <div className= "container">
                            {workExperience.map(e => {
                                return (
                                    <Fade
                                        left={isDesktop}
                                        bottom={isMobile}
                                        duration={1000}
                                        delay={500}
                                        distance="30px"
                                        key={e.id}
                                    >
                                        {
                                            <Paper elevation={1} className="p-3 work-card mb-3">
                                                <div className="row">
                                                    <div className="col-9">
                                                        <Typography className={classes.heading}>{e.workTitle}</Typography>
                                                    </div>
                                                    <div className="col-2">
                                                        <Typography>{e.date}</Typography>
                                                    </div>
                                                </div>
                                                <div className="entity-name">
                                                    <Typography  align='left'>
                                                        {e.link ?
                                                            <a href={e.Link} >{e.companyName} </a>
                                                            :
                                                            e.companyName
                                                        }
                                                    </Typography>
                                                </div>
                                                <hr />
                                                <Typography className={classes.details}>{e.details}</Typography>
                                            </Paper>
                                            // e.details ?
                                            //     <WorkAccordion details={e.details} head={e.data} />
                                            //     :
                                            //     <Typography variant="h5">{e.data}</Typography>
                                        }
                                    </Fade>
                                )
                            })}
                        </div>
                }
            </Container>
        </section>
    );
};

export default WorkTimeline;
